module.exports = __webpack_public_path__ + "static/media/galerija_2019 (13).d3a78d14.jpg";